import * as core from '../../../../../../../core'

import { query } from './anticipated-response-of-change-by-team.query'

export const RESOURCE = {
  payload: {
    alias: 'anticipated.response.of.change.by.team',
    description: 'Chart view of anticipated response of change by team',
    name: 'Anticipated Response of Change by Team',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
